import { Input } from "antd";
import { AiOutlineUser } from "react-icons/ai";
import styled from "styled-components";
import { SelectedOrganizationList } from "../../Modal/SettingComponents/OrganizationSelectionSetting/OrganizationSelect";
import { RiOrganizationChart } from "react-icons/ri";
import { AiOutlineClose } from "react-icons/ai";
import { AppPartType } from "../../../types";
import { FC } from "react";

const Styles = styled.div<{ $iconColor?: string }>`
  display: flex;
  .branch-icon {
    display: flex;
    align-items: center;
    background: ${(props) => props.$iconColor || "#174a83"};
    padding: 0 5px;
    border: 0.5px solid #f7f9fa;
    border-radius: 3px;
  }

  input {
    height: 36px;
  }
`;

const SelectList = styled.div`
  height: 75px;
  overflow-y: auto;
  padding: 7px;
  .select-option {
    line-height: 24px;
    color: #000;
    display: flex;
    align-items: center;
    svg {
      margin-right: 3px;
    }
    &.checked {
      color: #83b1e7;
    }
  }
`;

type PropsType = {
  appPart: AppPartType;
};

const EmployeeInfoSelection: FC<PropsType> = ({
  appPart: { item_config_data },
}) => {
  const iconColor = item_config_data?.employee_info_color || "#174a83";

  return item_config_data.preset_worker &&
    item_config_data.preset_workers &&
    item_config_data.preset_workers.length > 0 ? (
    <SelectList>
      {item_config_data.preset_workers?.map((o) => (
        <div className="select-option" key={o.name}>
          {o.name}
        </div>
      ))}
    </SelectList>
  ) : (
    <div style={{ height: "100%" }}>
      <Styles style={{ height: "100%" }} $iconColor={iconColor}>
        <Input.Search disabled />
        <div className="branch-icon">
          <AiOutlineUser size={20} color="#fff" />
        </div>
      </Styles>
      {item_config_data?.default_workers?.map((o) => (
        <SelectedOrganizationList key={o.id}>
          <div className="o-name">
            <RiOrganizationChart size={20} color={iconColor} />
            <div>{o.name}</div>
          </div>
          <AiOutlineClose className="o-close" />
        </SelectedOrganizationList>
      ))}
    </div>
  );
};

export default EmployeeInfoSelection;
